import { cancelPolicyAutoPayApi } from "./cancelPolicyAutoPayApi";

export default cancelPolicyAutoPayApi;
